// opervex-frontend/src/Opervex/Financial/Entries.js

class Entries {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  // Listar documentos financeiros
  async findAll(params = "") {
    return this.#_api.get(`/Financial/Entries${params}`);
  }

  async findAllModal(params) {
    return this.#_api.post("/Financial/Entries/SearchHelp", params);
  }

  // Buscar documento financeiro
  async findId(id) {
    return this.#_api.get(`/Financial/Entries/${id}`);
  }

  // Criar documento financeiro
  async create(data) {
    return this.#_api.post("/Financial/Entries", data);
  }

  // Alterar documento financeiro
  async update(id, data) {
    return this.#_api.put(`/Financial/Entries/${id}`, data);
  }

  // Criar uma baixa/compensação
  async settle(id, data) {
    return this.#_api.post(`/Financial/Entries/${id}/Settlements`, data);
  }

  async deleteSettlement(id, settlementId) {
    return this.#_api.delete(`/Financial/Entries/${id}/Settlements/${settlementId}`);
  }

  // Schema utilizado pelo SearchHelp / tabelas
  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
      },
      {
        key: "accountType",
        label: "Tipo",
        type: "string",
        visible: true,
        style: {
          align: "center",
        },
      },
      {
        key: "branchText",
        label: "Empresa/Filial",
        type: "string",
        visible: true,
      },
      {
        key: "documentType",
        label: "Tipo Documento",
        type: "string",
        visible: true,
      },
      {
        key: "referenceKey",
        label: "Referencia",
        type: "string",
        visible: true,
      },
      {
        key: "documentDate",
        label: "Data Documento",
        type: "dateOnly",
        visible: true,
      },
      {
        key: "dueDate",
        label: "Vencimento",
        type: "dateOnly",
        visible: true,
      },
      {
        key: "totalAmount",
        label: "Valor Total",
        type: "currency",
        visible: true,
        style: {
          align: "right",
        },
      },
      {
        key: "status",
        label: "Situação",
        type: "string",
        visible: true,
        cellStyles: [
          { value: "Baixado", className: "text-center rounded bg-success-subtle text-success-emphasis" },
          { value: "Parcial", className: "text-center rounded bg-warning-subtle text-warning-emphasis" },
          { value: "Em Aberto", className: "text-center rounded bg-primary-subtle text-primary-emphasis" },
        ],
      },
    ];
  }
}

export default Entries;
